export default __webpack_public_path__ + "img/logo.5260ebd3.png";